// import dependencies
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga";
import Clock from "react-live-clock";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import swal from "sweetalert";
import { Alert, Button, Collapse, Modal } from "react-bootstrap";
import moment from "moment";
import axios from "axios";

// import files and comopoents
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import PEMShareContentPopUp from "../PEM";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import Loader from "../UI Component/Loader/Loader";
import AppointmentPatient from "../AppointmentPatient";
import VideoChat from "../Twilio/VideoChat";
import PrescriptionComponent from "../DoctorVideo/PrescriptionComponent";
import DoctorPostShare from "../DoctorPostShare/DoctorPostShare";
import NotifiVisitor from "../InstantConsultation/NotifiVisitor/NotifiVisitor";
import ReScheduledModal from "../InstantConsultation/SideDrawer/ReScheduledModal";
import ReScheduledConformModal from "../InstantConsultation/SideDrawer/ReScheduledConformModal";
import CancelAppointmentModal from "../InstantConsultation/SideDrawer/CancelAppointmentModal";
import CallModal from "../DoctorDashboard/CallModal";
import OnHoldModal from "../DoctorVideo/onHoldModal";
import Popup from "../PEM/common/Popup";
import PrescriptionPdf from "../PrescriptionPdf";
import {
  getClinicDoctorList,
  getStaffDoctorList,
} from "../DashboardAppointmentsView/DashboardAppointmentsViewApiHandler";
import { patientFiles } from "../../Util/API Calls/APIList";
import clearStorage from "../../components/DoctorVideo/PatientInfoData";
import Notification from "../UI Component/Notification/Notification";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";

// import images and scss
import consultationImg from "../../assets/consultation_img.png";
import consultationImgGrey from "../../assets/grey_consultation_Img.png";
import shareIcon from "../../assets/pem_share_icon.svg";
import "./doctorVideoComponent.scss";

// import constant files
import { APPLICABLE_ROLE } from "../DashboardAppointmentsView/Constant";
import { USER_ROLE } from "../../Util/constants";
import {
  DOCTOR_CHECK_EXTEND,
  DOCTOR_END_MEET,
  DOCTOR_EXTEND_APPOINTMENT,
  DOCTOR_GET_RECEIVER_DOCUMENT,
  DOCTOR_RESCHEDULE_APPOINTMENT,
  DOCTOR_UPDATE_PRESCRIPTION,
  DOCTOR_VIEW_PATIENT_INFO,
  PUBLIC_CANCEL_APPOINTMENT_REQUEST,
  USER_ENGAGEMENT_ANALYTICS_DATA,
  USER_GET_DOCUMENT_REV1,
  USER_PRESCRIPTION_HISTORY,
} from "./constants/ApiConstant";

const formValid = (formErrors) => {
  let valid = true;
  Object.values(formErrors).forEach((val) => {
    if (!!val) {
      val.length > 0 && (valid = false);
    }
  });
  return valid;
};

const DoctorVideoComponent = (props) => {
  const { location } = props;
  const appointmentData = location.state;
  const { app_id, is_audio, is_video } = appointmentData;

  var tempDate = new Date();
  var yr = tempDate.getFullYear();
  var age =
    yr - (app_id?.patient_dob ? Number(app_id.patient_dob.substring(0, 4)) : 0);

  const [state, setState] = useState({
    sessionStartTime: moment(),
    oneMinuteOTP: true,
    showOtpTimer: false,
    activeTab: "consultation",
    otpTimer: {
      minutes: 0,
      seconds: 30,
    },
    appointmentData: appointmentData,
    appointmentDuration: moment(
      moment(app_id.appointment_end_date_time, "yyyy-MM-dd HH:mm:ssZ").format(
        "yyyy-MM-DD hh:mm:ssZ"
      )
    ).diff(
      moment(
        moment(
          app_id.appointment_start_date_time,
          "yyyy-MM-dd HH:mm:ssZ"
        ).format("yyyy-MM-DD hh:mm:ssZ")
      ),
      "minutes"
    ),
    endDateTime: null,
    is_audio: localStorage.getItem("audioStatus")
      ? localStorage.getItem("audioStatus")
      : is_audio,
    is_video: localStorage.getItem("videoStatus")
      ? localStorage.getItem("videoStatus")
      : is_video,
    appt_id: app_id,
    age: age,
    panelWidth: "0px",
    twilioURL: "",
    showPres: false,
    complaints: "",
    diagnosis: "",
    patient_height: "",
    patient_weight: "",
    lmp: "",
    relevance_history: "",
    lab_order_count: 0,
    doctor_recommendation: 0,
    medication_count: 0,
    showAlert: true,
    invalid_file: false,
    lab_results: [
      {
        test: "",
        instruction: "",
      },
    ],
    medication: [
      {
        drug: "",
        frequency: "",
        duration: "",
        instruction: "",
      },
    ],
    token: "",
    user_type: "",
    formErrors: {
      complaints: "",
      diagnosis: "",
      relevance_history: "",
    },
    sessionTimerStatus: false,
    start_for_timer_time_calculation: Date.now(),
    count_totaltime: "",
    savedtotalTime: 0,
    saveTime: "",
    message: "",
    confirmModal: false,
    terms1: true,
    loading: false,
    uploadingFile: false,
    identity:
      null /* Will hold the fake name assigned to the client. The name is generated by faker on the server */,
    roomName: "" /* Will store the room name */,
    roomNameErr: false /* Track error for room name TextField. This will    enable us to show an error message when this variable is true */,
    previewTracks: null,
    localMediaAvailable: false /* Represents the availability of a LocalAudioTrack(microphone) and a LocalVideoTrack(camera) */,
    hasJoinedRoom: false,
    activeRoom: null,
    roomId: null,
    initialValues: {},
    setLgShow: false,
    viewPrescription: "",
    prescriptionUploaded: false,
    prescription_not_added: true,
    consentFlag: false,
    callback: null,
    prescription_msg: null,
    size_exceeded: false,
    prescriptionTabIsOpen: false,
    purposeConsultationTabIsOpen: true,
    uploadPrescriptionTabIsOpen: false,
    documentsTabIsOpen: false,
    networkStatusText: "",
    networkShowAlert: false,
    prescriptionHistory: [],
    prescriptionHistoryPast: [],
    receiverDocuments: [],
    URL: patientFiles,
    notification: {
      type: "",
      messagetype: "",
      button: "",
      message: "",
      icon: "",
    },
    showNotification: false,
    newFileAdded: 0,
    receiverFiles: 0,
    patientFiles: 0,
    documentShow: false,
    fileName: "",
    fileURL: "",
    fileType: "",
    openSharPost: false,
    notifiVisitorCondition: false,
    consultation_type: "normal",
    isRescheduleClicked: false,
    messageSentModal: false,
    cancelAppointmentModalOprn: false,
    actual_start_time: "",
    showCallPatientModal: false,
    consultationPurpose: "",
    showPEMShare: false,
    showPopUp: false,
    isEndButtonClick: false,
    showOnHoldModal: false,
    doctorFilterList: [{ name: "All", value: "all" }],
    temp_doctor_selected: [],
  });

  const dashboardFilter = localStorage.getItem("dashboardFilters");
  const prevSelectedDoctor = localStorage.getItem(
    LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS
  );
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const user_type = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  let timersStop = false;
  let totaltime;
  let pageNavigation = false;
  let myInterval = false;
  let myInterval1 = false;

  //   Life cycle methods
  useEffect(() => {
    if (!location.state) {
      if (
        localStorage.getItem("id_token") !== null &&
        localStorage.getItem("user_type") === "doctor"
      ) {
        window.open(
          `${window.location.origin}/doctor/account/dashboard`,
          "_self"
        );
      } else {
        window.open(`${window.location.origin}/doctor/login`, "_self");
      }
    }
    return () => {
      clearInterval(myInterval);
      clearInterval(myInterval1);
    };
  }, [location.state]);

  useEffect(() => {
    setUpCall();
    registerAnalytics();
    checkNextMeeting();
  }, []);

  useEffect(() => {
    prescriptionHistory();
    patientPrescription();
    receiverPrescription();
    setTimeout(() => {
      setState((prevState) => ({ ...prevState, showAlert: false }));
    }, 20000);

    let mainSelectedDoctor =
      prevSelectedDoctor && JSON.parse(prevSelectedDoctor);
    let selectedDoctorId = [];
    if (mainSelectedDoctor) {
      let index = mainSelectedDoctor.findIndex(
        (da) => da.clinic_id === clinicId
      );
      selectedDoctorId = mainSelectedDoctor[index]?.doctors?.map(
        (data) => data.doctor_id
      );
    }
    if (user_type === APPLICABLE_ROLE.STAFF && !clinicId) {
      let payload = {
        "authorizer-principal-id": {
          user_type: 4,
          staff_id: staffId,
        },
        staff_id: staffId,
        search: "False",
        dr_name: "",
        dr_phone_no: "",
      };
      let auth = state.token
        ? state.token
        : localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN);
      const staffDoctorList = getStaffDoctorList(payload, auth);
      staffDoctorList.then(([res, err]) => {
        let arr = [];
        let arr1 = [];
        res &&
          res.map(
            (data) =>
              selectedDoctorId?.includes(data.doctor_id) &&
              arr.push(data.doctor_id) &&
              arr1.push(data)
          );
        let list = [{ name: "All", value: "all", doctor_id: arr }, ...arr1];
        setState((prevState) => ({
          ...prevState,
          doctorFilterList: list,
          temp_doctor_selected: res,
        }));
      });
    } else if (
      clinicId &&
      doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
      doctorRole !== USER_ROLE.RESOURCE_CONSULTANT
    ) {
      let params = { clinic_id: clinicId };
      let auth = state.token
        ? state.token
        : localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN);
      const clinicDoctorList = getClinicDoctorList(params, auth);
      clinicDoctorList.then(([res, err]) => {
        let arr = [];
        let arr1 = [];
        res &&
          res.map(
            (data) =>
              selectedDoctorId?.includes(data.doctor_id) &&
              arr.push(data.doctor_id) &&
              arr1.push(data)
          );

        let list = [{ name: "All", value: "all", doctor_id: arr }, ...arr1];
        setState((prevState) => ({
          ...prevState,
          doctorFilterList: list,
          temp_doctor_selected: res,
        }));
      });
    }
  }, []);

  useEffect(() => {
    return () => {
      cleartimersStop();
      clearTimeout(pageNavigation);
      localStorage.setItem("flagForSavedtotalTime", "");
      localStorage.setItem("savedtotalTime", "");
      setState((prev) => ({ ...prev, confirmModal: false }));
    };
  }, []);

  const displayNetworkText = (networkStatusText) => {
    if (!!networkStatusText) {
      setState((prevState) => ({
        ...prevState,
        networkStatusText,
        networkShowAlert: true,
      }));
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          networkShowAlert: false,
        }));
      }, 5000);
    } else {
      setState((prevState) => ({
        ...prevState,
        networkShowAlert: false,
      }));
    }
  };

  const endMeet = (roomClosed, forceStop, redirect, isManualEnd) => {
    const confirmModal = forceStop ? false : true;
    clearInterval(myInterval);
    clearInterval(myInterval1);
    localStorage.removeItem("extendTime");
    localStorage.removeItem("slot_extend");
    localStorage.removeItem("instantConsultId");
    localStorage.removeItem("cid");
    localStorage.removeItem("meeting_id");
    localStorage.removeItem("videoStatus");
    localStorage.removeItem("audioStatus");
    clearStorage.clearPatientData();
    if (redirect) {
      swal({
        title: "Appointment Ended ",
        text: "Your appointment has ended",
        icon: "success",
      }).then(() => {
        window.location.href = window?.location?.pathname?.includes("clinic")
          ? `/clinic/account/dashboard${
              dashboardFilter ? `?${dashboardFilter}` : ""
            }`
          : `/doctor/account/dashboard${
              dashboardFilter ? `?${dashboardFilter}` : ""
            }`;
        localStorage.setItem("openStarRatingPopups", true);
      });
      pageNavigation = setTimeout(() => {
        window.location.href = window?.location?.pathname?.includes("clinic")
          ? `/clinic/account/dashboard${
              dashboardFilter ? `?${dashboardFilter}` : ""
            }`
          : `/doctor/account/dashboard${
              dashboardFilter ? `?${dashboardFilter}` : ""
            }`;
        localStorage.setItem("openStarRatingPopups", true);
      }, 5000);
    } else {
      setState((prevState) => ({
        ...prevState,
        confirmModal: confirmModal,
        callback: roomClosed,
      }));
      if (forceStop) {
        endMeetingConfirm(isManualEnd);
      }
    }
  };

  const closeConfirm = () => {
    setState((prevState) => ({
      ...prevState,
      confirmModal: false,
    }));
  };

  const endMeetingConfirm = (isManualEnd) => {
    setState((prevState) => ({ ...prevState, openSharPost: false }));

    if (state.twilioURL) {
      setState((prevState) => ({ ...prevState, loading: true }));
      c2cPostApiHandler(DOCTOR_END_MEET, {
        appointment_id: state.appt_id.id,
        is_manual_end: isManualEnd,
      })
        .then(([response, error]) => {
          setState((prevState) => ({ ...prevState, loading: false }));

          if (response) {
            if (response.data) {
              setState((prevState) => ({ ...prevState, confirmModal: false }));
              if (response.status === 200) {
                swal({
                  title: "Appointment Ended",
                  text: "Your appointment has ended",
                  icon: "success",
                }).then(() => {
                  window.location.href = window?.location?.pathname?.includes(
                    "clinic"
                  )
                    ? `/clinic/account/dashboard${
                        dashboardFilter ? `?${dashboardFilter}` : ""
                      }`
                    : `/doctor/account/dashboard${
                        dashboardFilter ? `?${dashboardFilter}` : ""
                      }`;
                  localStorage.setItem("openStarRatingPopups", true);
                });

                setTimeout(() => {
                  window.location.href = window?.location?.pathname?.includes(
                    "clinic"
                  )
                    ? `/clinic/account/dashboard${
                        dashboardFilter ? `?${dashboardFilter}` : ""
                      }`
                    : `/doctor/account/dashboard${
                        dashboardFilter ? `?${dashboardFilter}` : ""
                      }`;
                  localStorage.setItem("openStarRatingPopups", true);
                }, 5000);
              } else {
                setState((prevState) => ({
                  ...prevState,
                  message: response.data.message,
                  dataload: false,
                }));
              }
            } else {
              setState((prevState) => ({
                ...prevState,
                response_message: "Something Went Wrong!Please Try Again!!",
                dataload: false,
              }));
            }
          }
        })
        .catch(() => {
          setState((prevState) => ({ ...prevState, loading: false }));

          window.location.href = window?.location?.pathname?.includes("clinic")
            ? `/clinic/account/dashboard${
                dashboardFilter ? `?${dashboardFilter}` : ""
              }`
            : `/doctor/account/dashboard${
                dashboardFilter ? `?${dashboardFilter}` : ""
              }`;
        });
    } else {
      swal({ title: "No meeting room available.", icon: "error" });
    }
  };

  const runTiming = (runTime) => {
    let savedtotalTime = state.savedtotalTime;
    let totalMSecc = runTime + savedtotalTime;

    let msec = Number(totalMSecc);
    if (msec >= 300000) {
      clearInterval(totaltime);
      setState((prevState) => ({
        ...prevState,
        saveTime: "00:00",
        savedtotalTime: "",
        start_for_timer_time_calculation: Date.now(),
      }));
      localStorage.setItem("savedtotalTime", 0);
      localStorage.setItem("flagForSavedtotalTime", false);
    } else {
      let saveTime;
      let seconds = msec / 1000;
      let hr = Math.floor(seconds / 3600);
      let min = Math.floor((seconds - 3600 * hr) / 60);
      let sec = Math.floor(seconds - 3600 * hr - 60 * min);
      if (hr > 0) {
        saveTime = hr + ":" + min + ":" + sec;
      } else {
        saveTime = min + ":" + sec;
      }
      setState((prevState) => ({
        ...prevState,
        saveTime: saveTime,
        savedtotalTime: msec,
        start_for_timer_time_calculation: Date.now(),
      }));
      localStorage.setItem("savedtotalTime", msec);
    }
  };

  const startTimer = () => {
    totaltime = setInterval(() => {
      setState((prev) => {
        const count_totaltime =
          Date.now() - prev.start_for_timer_time_calculation;
        return { ...prev, count_totaltime };
      });
      runTiming(state.count_totaltime);
    }, 1000);
  };

  const cleartimersStop = () => {
    if (timersStop) {
      clearTimeout(timersStop);
      timersStop = false;
    }
  };

  const startSessionTimer = (mint, endTime, actualStartTime) => {
    let endDateTime;
    if (endTime) {
      endDateTime = moment(endTime).format();
    } else {
      endDateTime = getAppointmentEndTime(actualStartTime);
    }

    let timeDifference = Math.abs(moment().diff(endDateTime, "milliseconds"));
    let alertInterval = timeDifference - 60000 * mint;
    if (alertInterval > 0) {
      timersStop = setTimeout(() => {
        if (!state.sessionTimerStatus) {
          medicationTimeExtensionCheck(mint);
        }
      }, alertInterval);
    }
  };

  const medicationTimeExtensionCheck = (mint) => {
    c2cPostApiHandler(DOCTOR_CHECK_EXTEND, {
      date: state.appt_id.appointment_date,
      appointment_id: state.appt_id.id,
    }).then(([response, error]) => {
      if (response) {
        if (response.data.slot_extend) {
          setState((prevState) => ({
            ...prevState,
            notification: {
              type: "success",
              messagetype: "extend the consultation",
              title: "Your session will end in  " + mint + "min.",
              button2: true,
              icon: "fa-clock-o",
              message: "Would you like to",
              endMessage: " period into next time slot ?",
            },
            sessionTimerStatus: true,
            showNotification: true,
          }));
          if (mint != 1) {
            otpTimer();
          }
        } else {
          if (
            state.appointmentDuration === 5 ||
            state.appointmentDuration === 55
          ) {
            setState((prevState) => ({
              ...prevState,
              notification: {
                type: "error",
                messagetype: "consultation can't be extended.",
                title: "Your session will end in  " + mint + "min.",
                button: "",
                icon: "fa-clock-o",
                message: "Since the next slot is blocked, the currrent",
              },
              sessionTimerStatus: true,
              showNotification: true,
            }));
          } else {
            setState((prevState) => ({
              ...prevState,
              notification: {
                type: "error",
                messagetype: "consultation can't be extended.",
                title: "Your session will end in  5min.",
                button: "",
                icon: "fa-clock-o",
                message: "Since the next slot is blocked, the currrent",
              },
              sessionTimerStatus: true,
              showNotification: true,
            }));
          }
        }
      }
    });
  };

  const getBrowserName = () => {
    // Firefox 1.0+
    let isFirefox = typeof InstallTrigger !== "undefined";

    // Safari 3.0+ "[object HTMLElementConstructor]"
    let isSafari =
      /constructor/i.test(window.HTMLElement) ||
      ((p) => {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && window["safari"].pushNotification)
      );

    // Internet Explorer 6-11
    let isIE = /*@cc_on!@*/ false || !!document.documentMode;

    // Edge 20+
    let isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 79
    let isChrome =
      !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // Edge (based on chromium) detection
    let isEdgeChromium = isChrome && navigator.userAgent.indexOf("Edg") != -1;

    // Blink engine detection
    let isBlink = isChrome && !!window.CSS;

    if (isFirefox) return "FireFox";
    if (isSafari) return "Safari";
    if (isIE && !isEdge) return "IE";
    if (isEdge) return "Edge";
    if (isChrome) return "Chrome";
    if (isEdgeChromium) return "EdgeChromium";
    if (isBlink) return "Blink-based";
  };

  const registerAnalytics = () => {
    const payload = {
      usecase: "consultation",
      user_type: "1",
      device_details: {
        device_type: "desktop",
        device_manufacturer: "",
        os_version: window.navigator.userAgent.substring(
          window.navigator.userAgent.indexOf("(") + 1,
          window.navigator.userAgent.indexOf(")")
        ),
        os_name: window.navigator.userAgent.substring(
          window.navigator.userAgent.indexOf("(") + 1,
          window.navigator.userAgent.indexOf(")")
        ),
        application_type: "web",
        application_version: "1.0",
        browser_name: getBrowserName(),
        browser_version: window.navigator.userAgent.substring(
          window.navigator.userAgent.lastIndexOf(")") + 1
        ),
      },
      appointment_data: {
        appointment_id: state.appt_id.id,
        doctor_fees: "0",
      },
    };

    c2cPostApiHandler(USER_ENGAGEMENT_ANALYTICS_DATA, payload)
      .then(() => {})
      .catch((err) => C2CConsole.error(err));
  };

  const setUpCall = () => {
    getConsultationPurpose();
    startTimer();
    let location = props.history;

    let type = state.is_audio ? "Audio" : "Video";
    ReactGA.event({
      category: "start_appointment",
      action: type,
      label: "doctor",
    });
    afterLoginApiAxios
      .post(
        "user/start-meeting",
        {
          appointment_id: state.appt_id.id,
          in_progress: state.appt_id?.in_progress,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      // c2cPostApiHandler(USER_START_MEETING, {
      //   appointment_id: state.appt_id.id,
      //   in_progress: state.appt_id?.in_progress,
      // })
      .then((response) => {
        if (response) {
          let responseData = response.data;
          const { identity, token, actual_start_time } = response.data;
          setState((prev) => ({ ...prev, identity, token, actual_start_time }));

          if (localStorage.getItem("slot_extend") === "true") {
            startSessionTimer(
              1,
              localStorage.getItem("extendTime"),
              actual_start_time
            );
            setState((prev) => ({
              ...prev,
              endDateTime: localStorage.getItem("extendTime"),
            }));
          } else {
            setState((prev) => ({
              ...prev,
              endDateTime: getAppointmentEndTime(actual_start_time),
            }));
            startSessionTimer(
              1,
              localStorage.getItem("extendTime"),
              actual_start_time
            );
          }

          if (responseData) {
            if (responseData.statusCode === 200) {
              localStorage.removeItem("instantConsultId");
              localStorage.removeItem("cid");
              localStorage.removeItem("meeting_id");
              setState((prev) => ({ ...prev, twilioURL: token }));
              checkNextMeeting();
            } else if (responseData.statusCode == 515) {
              localStorage.removeItem("videoStatus");
              localStorage.removeItem("audioStatus");
              swal({
                title: "Cannot Join Meeting",
                text: responseData.message,
                type: "failed",
              }).then(function () {
                if (
                  window?.location?.pathname &&
                  window?.location?.pathname?.includes("clinic")
                ) {
                  window.location.href = `/clinic/account/dashboard${
                    dashboardFilter && `?` + dashboardFilter
                  }`;
                } else {
                  window.location.href = `/doctor/account/dashboard${
                    dashboardFilter && `?` + dashboardFilter
                  }`;
                }
              });
            } else {
              localStorage.removeItem("videoStatus");
              localStorage.removeItem("audioStatus");
              swal({
                title: "Oops ! ",
                text: "Something went wrong. Please rejoin.",
                type: "failed",
              }).then(() => {});
            }
          }
        }
      })
      .catch(() => {
        swal({
          title: "Oops ! ",
          text: "Something went wrong. Please rejoin.",
          type: "failed",
        }).then(() => {});
      });
    let token = localStorage.getItem("id_token");
    let user_type = localStorage.getItem("user_type");

    setState((prevState) => ({
      ...prevState,
      token: token,
      user_type: user_type,
    }));
    if (token && user_type == "doctor") {
    } else {
      location.push("/noaccess");
    }
  };

  const checkNextMeeting = () => {
    let mytimer = setInterval(() => {
      let nextMeet = localStorage.getItem("next_meeting");
      if (nextMeet !== null) {
        let upcoming = moment(nextMeet, "DD-MM-YYYY HH:mm:ss");
        let current = moment(new Date());
        let diff = moment.duration(upcoming.diff(current));
        let minutes = diff.asMinutes();
        if (minutes > 0 && minutes <= 5) {
          setState((prevState) => ({
            ...prevState,
            notifiVisitorCondition: true,
          }));
          clearInterval(mytimer);
        }
      }
    }, 30000);
  };

  const prescriptionHistory = () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    c2cPostApiHandler(USER_PRESCRIPTION_HISTORY, {
      doctor_id: userId,
      appointment_id: state.appt_id.id,
    })
      .then(([res, err]) => {
        setState((prevState) => ({ ...prevState, loading: false }));
        if (res.data.statusCode === 200) {
          let files = [];

          if (res.data?.prescription_data?.images) {
            res.data.prescription_data.images.map((item, index) => {
              files.push({
                document_title: "Medical Record" + (index + 1) + ".",
                file_size: 2.0,
                presigned_url: item,
                created_at: item.HTTPHeaders.date,
              });
            });
          }
          setState((prevState) => ({
            ...prevState,
            prescriptionHistoryPast: files,
          }));
        }
      })
      .catch(() => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
      });
  };

  const otpTimer = () => {
    setState((prevState) => ({
      ...prevState,
      showOtpTimer: true,
    }));
    const { oneMinuteOTP } = state;
    let myInterval = setInterval(() => {
      const { seconds, minutes } = state.otpTimer;
      if (seconds > 0) {
        setState((prevState) => ({
          ...prevState,
          otpTimer: {
            ...prevState.otpTimer,
            seconds: prevState.otpTimer.seconds - 1,
          },
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          setState((prevState) => ({
            ...prevState,
            showOtpTimer: false,
            showNotification: false,
            otpTimer: {
              ...prevState.otpTimer,
              seconds: 30,
            },
          }));
          if (oneMinuteOTP) {
            closeNotification();
          }
        } else {
          setState((prevState) => ({
            ...prevState,
            otpTimer: {
              minutes: prevState.otpTimer.minutes - 1,
              seconds: 59,
            },
          }));
        }
      }
    }, 1000);
  };

  const selectRecommendation = (name) => (event) => {
    const { name, value } = event.target;

    if (value == 1) {
      setState((prevState) => ({
        ...prevState,
        doctor_recommendation: 1,
      }));
    } else if (value == 2) {
      setState((prevState) => ({
        ...prevState,
        doctor_recommendation: 2,
      }));
    }
  };

  const closePres = () => {
    setState((prevState) => ({
      ...prevState,
      showPres: false,
    }));
  };

  const createRecord = (name) => (event) => {
    const { name, value } = event.target;
    let lab_order_count = state.lab_order_count;
    lab_order_count = parseInt(lab_order_count) + parseInt(1);
    let medication_count = state.medication_count;
    medication_count = parseInt(medication_count) + parseInt(1);

    if (value == 1) {
      let obj = {
        test: "",
        instruction: "",
      };
      let test_arr = state.lab_results;
      test_arr.push(obj);
      setState((prevState) => ({ ...prevState, lab_results: test_arr }));
    } else if (value == 2) {
      let obj = {
        drug: "",
        frequency: "",
        duration: "",
        instruction: "",
      };
      let test_arr = state.medication;
      test_arr.push(obj);
      setState((prevState) => ({ ...prevState, medication: test_arr }));
    }
  };

  const handleChange = (name) => (event) => {
    const { name, value } = event.target;
    let formErrors = state.formErrors;
    let data_index = event.target.getAttribute("data-index");
    let data_text = event.target.getAttribute("data-text");
    let test_arr = [];
    if (name == "complaints") {
      formErrors.complaints =
        event.target.value != ""
          ? ""
          : "Please Provide data For Chief Complaints";
      setState((prevState) => ({
        ...prevState,
        complaints: event.target.value,
        formErrors: formErrors,
      }));
    } else if (name == "diagnosis") {
      formErrors.diagnosis =
        event.target.value != "" ? "" : "Please Provide data For Diagnosis";
      setState((prevState) => ({
        ...prevState,
        diagnosis: event.target.value,
        formErrors: formErrors,
      }));
    } else if (name == "height") {
      setState((prevState) => ({
        ...prevState,
        patient_height: event.target.value,
        formErrors: formErrors,
      }));
    } else if (name == "weight") {
      setState((prevState) => ({
        ...prevState,
        patient_weight: event.target.value,
      }));
    } else if (name == "lmp") {
      setState((prevState) => ({ ...prevState, lmp: event.target.value }));
    } else if (name == "history") {
      setState((prevState) => ({
        ...prevState,
        relevance_history: event.target.value,
      }));
    } else if (name == "investigations") {
      setState((prevState) => ({
        ...prevState,
        suggested_investigations: event.target.value,
      }));
    } else if (
      name == "lab_order_test_" + data_index ||
      name == "lab_order_inst_" + data_index
    ) {
      if (data_text == "test") {
        test_arr = state.lab_results;
        test_arr[data_index] = {
          test: value,
          instruction: test_arr[data_index].instruction,
        };
      } else {
        test_arr = state.lab_results;
        test_arr[data_index] = {
          test: test_arr[data_index].test,
          instruction: value,
        };
      }
      setState((prevState) => ({ ...prevState, lab_results: test_arr }));
    } else {
      if (data_text == "drug") {
        test_arr = state.medication;
        test_arr[data_index] = {
          drug: value,
          frequency: test_arr[data_index].frequency,
          duration: test_arr[data_index].duration,
          instruction: test_arr[data_index].instruction,
        };
      } else if (data_text == "frequency") {
        test_arr = state.medication;
        test_arr[data_index] = {
          drug: test_arr[data_index].drug,
          frequency: value,
          duration: test_arr[data_index].duration,
          instruction: test_arr[data_index].instruction,
        };
      } else if (data_text == "duration") {
        test_arr = state.medication;
        test_arr[data_index] = {
          drug: test_arr[data_index].drug,
          frequency: test_arr[data_index].frequency,
          duration: value,
          instruction: test_arr[data_index].instruction,
        };
      } else {
        test_arr = state.medication;
        test_arr[data_index] = {
          drug: test_arr[data_index].drug,
          frequency: test_arr[data_index].frequency,
          duration: test_arr[data_index].duration,
          instruction: value,
        };
        setState((prevState) => ({ ...prevState, medication: test_arr }));
      }
    }
  };

  const getConsultationPurpose = () => {
    const payload = {
      patient_id: state?.appt_id?.patient_id,
      doctor_id: state?.appt_id?.doctor_id,
      patient_appointment_id: state?.appt_id.id,
      patient_name: state?.appt_id?.patient_name,
    };
    c2cPostApiHandler(DOCTOR_VIEW_PATIENT_INFO, payload)
      .then(([response, error]) => {
        if (response && response.status === 200) {
          setState((prevState) => ({
            ...prevState,
            consultationPurpose:
              response.data.result?.patient_info?.purpose_of_appointment,
          }));
        }
      })
      .catch((error) => {
        C2CConsole.log(error);
      });
  };

  // not using this on sumbit and not calling update-prescription api (may be to old code)
  const onSubmit = () => {
    const {
      patient_height,
      patient_weight,
      lmp,
      relevance_history,
      suggested_investigations,
    } = state;
    setState((prevState) => ({ ...prevState, consentFlag: true }));

    if (state.token && state.user_type == "doctor") {
      if (
        state.complaints != "" &&
        state.diagnosis != "" &&
        state.terms1 &&
        formValid(state.formErrors)
      ) {
        let check_lab_results = [];
        let check_medication = [];
        if (state.lab_results.length > 0) {
          state.lab_results.forEach((Data) => {
            let obj = {
              test: Data.test ? Data.test : "",
              instruction: Data.instruction ? Data.instruction : "",
            };
            check_lab_results.push(obj);
          });
        }
        if (state.medication.length > 0) {
          state.medication.forEach((Data) => {
            let obj = {
              drug: Data.drug ? Data.drug : "",
              frequency: Data.frequency ? Data.frequency : "",
              duration: Data.duration ? Data.duration : "",
              instruction: Data.instruction ? Data.instruction : "",
            };
            check_medication.push(obj);
          });
        }

        setState((prevState) => ({
          ...prevState,
          loading: true,
          consentFlag: false,
        }));
        ReactGA.event({
          category: "Prescription",
          action: "save",
          label: state.appt_id.id,
        });

        const payload = {
          appointment_id: state.appt_id.id,
          complaints: state.complaints.trim(),
          diagnosis: state.diagnosis.trim(),
          doctor_recommendation: state.doctor_recommendation,
          lab_results: check_lab_results,
          patient_height: patient_height,
          patient_weight: patient_weight,
          lmp: lmp,
          relevance_history: relevance_history,
          suggested_investigations: suggested_investigations,
          share_prescription: true,
          medication: check_medication,
          finalize: false,
        };

        c2cPostApiHandler(DOCTOR_UPDATE_PRESCRIPTION, payload)
          .then(([response, error]) => {
            setState((prevState) => ({ ...prevState, loading: false }));
            if (response) {
              if (response?.data?.statusCode == 200) {
                let message = response.data.message;
                swal({
                  title: "Create Prescription",
                  text: message,
                  type: "success",
                }).then(() => {});
              } else {
                let message = response.data.message;
                swal({
                  title: "Failed!",
                  text: message,
                  type: "error",
                  icon: "warning",
                }).then(() => {});
              }
            }
          })
          .catch(() => {
            setState((prevState) => ({ ...prevState, loading: false }));
          });
      } else {
        let formErrors = state.formErrors;
        formErrors = {
          complaints: "",
          diagnosis: "",
        };
        if (state.complaints == "" || state.formErrors.complaints) {
          formErrors.complaints = "Please Provide Data for Chief Complaints";
          setState((prevState) => ({ ...prevState, formErrors }));
        }
        if (state.diagnosis == "" || state.formErrors.diagnosis) {
          formErrors.diagnosis = "Please Provide Data for Diagnosis";
          setState((prevState) => ({ ...prevState, formErrors }));
        }
        swal({
          title: formErrors.complaints || formErrors.diagnosis,
          icon: "warning",
        });
      }
    } else {
      props.history.push("/noaccess");
    }
  };

  const patientPrescription = () => {
    myInterval1 = setInterval(() => {
      c2cPostApiHandler(USER_GET_DOCUMENT_REV1, {
        appointment_id: state.appt_id.id,
      })
        .then(([response, error]) => {
          if (response) {
            let responseData = response.data;
            setState((prevState) => ({ ...prevState, uploadingFile: false }));

            if (
              responseData &&
              response.data.hasOwnProperty("statusCode") &&
              response.data.statusCode == 200
            ) {
              let latestFiles =
                (responseData.data &&
                  responseData.data.length > 0 &&
                  responseData.data) ||
                [];

              setState((prevState) => {
                let files = [...prevState.prescriptionHistory]; // Get the latest state correctly
                let addedNew = false;
                let newFileAdded = prevState.newFileAdded;

                latestFiles.forEach((prec) => {
                  let oldPrec = prevState.prescriptionHistory.find(
                    (item) => item.document_id === prec.document_id
                  );

                  if (!oldPrec) {
                    files.push({ ...prec, new: true });
                    addedNew = true;
                    newFileAdded += 1;
                  }
                });

                if (addedNew) {
                  return {
                    ...prevState,
                    notification: {
                      type: "success",
                      messagetype: "Patient's Medical History",
                      button: "",
                      message: "A new document has been added under",
                      icon: "fa-file-text",
                      title: "New Document",
                    },
                    showNotification: true,
                    newFileAdded: newFileAdded,
                    prescriptionHistory: files.sort(
                      (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    ),
                    patientFiles: responseData.data.length,
                  };
                }

                return {
                  ...prevState,
                  prescriptionHistory: [
                    ...files.sort(
                      (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    ),
                    ...prevState.prescriptionHistoryPast, // 🔹 Merging past history properly
                  ],
                  patientFiles: responseData.data.length,
                };
              });
            } else {
              setState((prevState) => ({
                ...prevState,
                message: "Fetch Failed",
                response_message: "Something Went Wrong! Please Try Again!!",
                dataload: false,
                uploadingFile: false,
              }));
            }
          }
        })
        .catch(() => {
          alert("Fetch Prescription Failed! Please try again!!");
          setState((prevState) => ({
            ...prevState,
            message: "Fetch Failed",
            uploadingFile: false,
          }));
        });
    }, 6000);
  };

  const receiverPrescription = () => {
    myInterval = setInterval(() => {
      c2cPostApiHandler(DOCTOR_GET_RECEIVER_DOCUMENT, {
        appointment_id: state.appt_id.id,
        "authorizer-principal-id": {
          user_type: 1,
        },
      })
        .then(([response, error]) => {
          if (response) {
            let responseData = response.data;
            setState((prevState) => ({ ...prevState, uploadingFile: false }));

            if (
              responseData &&
              response.data.hasOwnProperty("statusCode") &&
              response.data.statusCode == 200
            ) {
              let latestFiles =
                responseData.data?.length > 0 ? responseData.data : [];

              setState((prevState) => {
                let files = [...prevState.receiverDocuments]; // Ensure correct state reference
                let addedNew = false;
                let newFileAdded = prevState.newFileAdded;

                latestFiles.forEach((doc) => {
                  let oldDoc = files.find((item) => item.id === doc.id);

                  if (!oldDoc) {
                    files.push({ ...doc, new: true });
                    addedNew = true;
                    newFileAdded += 1;
                  }
                });

                if (addedNew) {
                  return {
                    ...prevState,
                    notification: {
                      type: "success",
                      messagetype: "Patient's Medical History",
                      button: "",
                      message: "A new document has been added under",
                      icon: "fa-file-text",
                      title: "New Document",
                    },
                    showNotification: true,
                    newFileAdded: newFileAdded,
                    receiverDocuments: files.sort(
                      (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    ),
                    receiverFiles: responseData.data.length,
                  };
                }

                return {
                  ...prevState,
                  receiverDocuments: files.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at)
                  ),
                  receiverFiles: responseData.data.length,
                };
              });
            } else {
              setState((prevState) => ({
                ...prevState,
                message: "Fetch Failed",
                response_message: "Something Went Wrong! Please Try Again!!",
                dataload: false,
                uploadingFile: false,
              }));
            }
          }
        })
        .catch(() => {
          alert("Fetch Prescription Failed! Please try again!!");
          setState((prevState) => ({
            ...prevState,
            message: "Fetch Failed",
            uploadingFile: false,
          }));
        });
    }, 6000);
  };

  const successNotification = () => {
    c2cPostApiHandler(DOCTOR_EXTEND_APPOINTMENT, {
      date: state.appt_id.appointment_date,
      appointment_id: state.appt_id.id,
    }).then(([response, error]) => {
      let responseData = response.data;
      let endTime = responseData.date + " " + responseData.extend_time;

      localStorage.setItem("extendTime", endTime);
      setState((prev) => ({
        ...prev,
        sessionTimerStatus: false,
        oneMinuteOTP: false,
        showNotification: false,
        appt_id: {
          ...prev.appt_id,
          appointment_end_date_time: endTime,
          appointment_start_date_time: prev.actual_start_time,
        },
      }));
      props.history.replace({
        ...props.history.location,
        state: {
          app_id: {
            ...state.appt_id,
            appointment_end_date_time: endTime,
            appointment_start_date_time: state.actual_start_time,
          },
        },
      });
      startSessionTimer(1, endTime);
      window.location.reload();
    });
  };

  const viewDocument = (result, fileType, fileName) => {
    setState((prevState) => ({
      ...prevState,
      documentShow: true,
      fileURL: result.presigned_url_view,
      fileName: fileName,
      fileType: fileType,
      prescriptionHistory: prevState.prescriptionHistory.map((item) => {
        item.document_id == result.document_id && delete item.new;
        return item;
      }),
    }));
  };

  const closeNotification = () => {
    if (state.notification?.button2) {
      setState((prevState) => ({
        ...prevState,
        showNotification: false,
        sessionTimerStatus: false,
      }));
      startSessionTimer(1);
    }
    if (state.notification?.button) {
      setState((prevState) => ({
        ...prevState,
        showNotification: false,
        sessionTimerStatus: true,
      }));
    }
    setState((prevState) => ({
      ...prevState,
      notification: {
        type: "",
        messagetype: "",
        button: "",
        message: "",
        icon: "",
        title: "",
      },
      showNotification: false,
      documentShow: false,
      fileName: "",
      fileURL: "",
      fileType: "",
    }));
  };

  const setNotifiVisitorCondition = () => {
    setState((prevState) => ({ ...prevState, notifiVisitorCondition: false }));
  };

  const instantRescheduleAppointmentNotifi = () => {
    setState((prevState) => ({ ...prevState, isRescheduleClicked: true }));
  };

  const instantReScheduledModal = () => {
    c2cPostApiHandler(DOCTOR_RESCHEDULE_APPOINTMENT, {
      appointment_id: localStorage.getItem("next_appt_id"),
      doctor_id: userId,
      consultation_type: "instant_consultation",
    })
      .then(([res, err]) => {
        if (res.data.statusCode === 200) {
          setState((prevState) => ({
            ...prevState,
            isRescheduleClicked: false,
            messageSentModal: true,
          }));
        } else if (res.data.statusCode === 516) {
          swal({
            title: "Unable to reschedule appointment",
            text: res.data.message,
            icon: "error",
            button: "Okay",
          });
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const notiFiHandleClose = () => {
    setState((prevState) => ({ ...prevState, isRescheduleClicked: false }));
  };

  const notiFiClosePopup = () => {
    setState((prevState) => ({
      ...prevState,
      messageSentModal: false,
      notifiVisitorCondition: false,
    }));
  };

  const instantCancelAppointment = () => {
    setState((prevState) => ({
      ...prevState,
      cancelAppointmentModalOprn: true,
    }));
  };

  const cancelAppointInstantData = () => {
    c2cPostApiHandler(PUBLIC_CANCEL_APPOINTMENT_REQUEST, {
      appointment_id: localStorage.getItem("next_appt_id"),
      doctor_id: userId,
      reason: "instant",
    })
      .then(([res, err]) => {
        if (res.data.statusCode === 200) {
          setState((prevState) => ({
            ...prevState,
            cancelAppointmentModalOprn: false,
            notifiVisitorCondition: false,
          }));
        } else {
          swal({
            title: "Unable to cancel appointment",
            text: res.data.message,
            icon: "warning",
            button: "Okay",
          });
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const cancelAppointmentModalClose = () => {
    setState((prevState) => ({
      ...prevState,
      cancelAppointmentModalOprn: false,
    }));
  };

  // === Logic for +/- 12 hours impmentation to get appointment end time ===
  // Find out the slot duration by taking difference between appointment start time and end time.
  // Add the slot duration minutes to sessionStartTime to set endDateTime.
  const getAppointmentEndTime = (actualStartTime) => {
    let tempActualStartTime = actualStartTime
      ? actualStartTime
      : state.actual_start_time;
    if (tempActualStartTime) {
      let startTime = moment(tempActualStartTime).format("YYYY-MM-DD HH:mm:ss");
      return moment(startTime)
        .add(state.appointmentDuration, "minutes")
        .format();
    } else {
      return state.appt_id.appointment_end_date_time;
    }
  };

  const clickHandler = () => {
    setState((prevState) => ({ ...prevState, showCallPatientModal: true }));
  };

  const setShowCallPatientModal = () => {
    setState((prevState) => ({ ...prevState, showCallPatientModal: false }));
  };

  const downloadURI = async (url, name, fileType) => {
    const blob = await axios.get(url, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
      responseType: "blob",
    });
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob.data);
    a.href = href;
    a.download = name + "." + fileType.trim();
    a.click();
  };

  const sharePEMClick = () => {
    setState((prevState) => ({ ...prevState, showPEMShare: true }));
  };

  const pemCloseBtnCallback = (closeBtnState = false) => {
    setState((prevState) => ({ ...prevState, showPEMShare: false }));
    if (!closeBtnState) {
      setState((prevState) => ({ ...prevState, showPopUp: true }));
    }
    if (state.isEndButtonClick) {
      endMeet(true, true, false, true);
    }
  };

  const renderPEMButton = () => {
    return (
      <div
        style={{
          width: "100%",
          backgroundColor: "white",
          height: "50px",
          borderRadius: "25px",
          marign: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => sharePEMClick()}
      >
        <div style={{ display: "flex" }}>
          <img src={shareIcon} alt="" />
          <div
            style={{
              color: "#17BAE0",
              fontWeight: "bolder",
              fontSize: "16px",
              marginLeft: "10px",
            }}
          >
            Share Patient Education Content
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid pl-0 pr-0 doctor-contanier">
      {state.showPEMShare && (
        <PEMShareContentPopUp
          patientId={state?.appt_id?.patient_id}
          appointment_id={state?.appt_id?.appointment_id}
          pemCloseBtnCallback={pemCloseBtnCallback}
        />
      )}
      {state.documentShow && (
        <DocumentContainer
          cancelHandler={() => closeNotification()}
          url={state.fileURL}
          fileName={state.fileName}
          fileType={state.fileType}
        />
      )}
      {state.loading && <Loader />}
      <header>
        <div className="container-fluid">
          <div className="row ai-center">
            <div className="col-6 col-md-3 mobile_view_p_l_0">
              <img
                src={process.env.PUBLIC_URL + "/images/HN_logo.png"}
                style={{ width: "70%" }}
                alt=""
              />
            </div>
            <div className="col-6 col-md-9 mobile_view_p_0">
              <div className="row m-0 for_call_patient">
                <div className="col-9 p-0 dashboard_call_patient">
                  <div className="desk-video-duration video-duration df ai-center">
                    <p className="mr-5">
                      <span>
                        <Clock format={"HH:mm:ss"} ticking={true} />
                      </span>
                    </p>
                    <p>
                      <span>Patient:</span> {state.appt_id.patient_name}
                    </p>
                  </div>
                  <Link
                    className="login-btn"
                    href=""
                    onClick={() => {
                      clearInterval(myInterval);
                      clearInterval(myInterval1);
                    }}
                    to={`${
                      window?.location?.pathname?.includes("clinic")
                        ? `/clinic/account/dashboard${
                            dashboardFilter && `?` + dashboardFilter
                          }`
                        : `/doctor/account/dashboard${
                            dashboardFilter && `?` + dashboardFilter
                          }`
                    }`}
                  >
                    Dashboard
                  </Link>
                </div>
                <div className="col-3 p-0 custom-btn-div mobile_view call_button_mobile">
                  <button
                    type="button"
                    className="btn  border rounded-pill custom-btn cursor-pointer"
                    onClick={() => clickHandler()}
                  >
                    <div className="call-icon-div">
                      <i class="fa fa-phone call-icon" aria-hidden="true"></i>
                    </div>
                    <div className="call_by_text" style={{ color: "#10a74a" }}>
                      Call By Phone
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="header-bottom-shadow">
        <div className="container-fluid">
          <div className="row">
            <div
              className={`nav-tab mr-tab check_history ${
                state.activeTab === "consultation" && "nav-tab-active"
              }`}
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  activeTab: "consultation",
                }))
              }
            >
              {state.activeTab === "consultation" ? (
                <img className="icon-font pr-2" src={consultationImg} />
              ) : (
                <img className="icon-font pr-2" src={consultationImgGrey} />
              )}
              Consultation
            </div>

            <div
              className={`nav-tab check_history ${
                state.activeTab === "apptHistory" && "nav-tab-active"
              }`}
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  activeTab: "apptHistory",
                }))
              }
            >
              <i className="fa fa-list icon-font pr-2" aria-hidden="true"></i>{" "}
              View History
            </div>
          </div>
        </div>
      </div>
      {state.activeTab === "apptHistory" && (
        <AppointmentPatient
          details={state.appt_id}
          doctorFilterList={state.doctorFilterList}
          temp_doctor_selected={state.temp_doctor_selected}
          heading={"View History"}
          handleTab={() => {
            setState((prevState) => ({
              ...prevState,
              activeTab: "consultation",
            }));
          }}
        >
          <div className="mb-video-duration video-duration">
            <p>
              <span>
                <Clock format={"HH:mm:ss"} ticking={true} />
              </span>
            </p>
            <p>
              <span>Patient:</span> {state.appt_id.patient_name}
            </p>
          </div>
        </AppointmentPatient>
      )}

      <section
        style={{
          display: state.activeTab === "apptHistory" ? "none" : "",
        }}
        className="pro-body-content"
      >
        <div className="pro-doctor-video scroll_style">
          <div>
            <div className="video-col-right patient_video">
              <div className="mb-video-duration video-duration">
                <p>
                  <span>
                    <Clock format={"HH:mm:ss"} ticking={true} />
                  </span>
                </p>
                <p>
                  <span>Patient:</span> {state.appt_id.patient_name}
                </p>
              </div>

              <VideoChat
                endDateTime={state.endDateTime}
                token={state.twilioURL}
                endSession={endMeet}
                displayNetworkText={displayNetworkText}
                isAudioCall={state.is_audio}
                isVideoCall={state.is_video}
                appointment={state.appt_id}
                history={props.history}
                handleOnHold={() => {
                  setState((prevState) => ({
                    ...prevState,
                    showOnHoldModal: true,
                  }));
                }}
              />
              {state.networkShowAlert ? (
                <Alert variant={"dark"}>
                  <span>{state.networkStatusText}</span>
                </Alert>
              ) : (
                ""
              )}
              <Alert variant={"dark"}>
                <button
                  onClick={() => {
                    window.location.reload();
                  }}
                  style={{
                    background: "#bfbfbe",
                    width: "3rem",
                    borderRadius: "30px",
                  }}
                >
                  <i className="fa fa-refresh"></i>
                </button>
                <span>
                  &nbsp; Please click here to refresh your browser in case if
                  you received call during the consultation.
                </span>
              </Alert>
            </div>

            <div className="video-col-left p-0 prescription_scroll_style">
              <h3
                className="py-3 pl-3 pr-4 pb-0 mb-0 doctor-video-collapse-header"
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    purposeConsultationTabIsOpen:
                      !prevState.purposeConsultationTabIsOpen,
                  }))
                }
              >
                Purpose Of Consultation
                {state.purposeConsultationTabIsOpen ? (
                  <i
                    className="fa fa-angle-down"
                    style={{ transform: "rotate(180deg)" }}
                  ></i>
                ) : (
                  <i
                    className="fa fa-angle-up"
                    style={{ transform: "rotate(180deg)" }}
                  ></i>
                )}
              </h3>
              <Collapse
                id="purposeCollapse"
                in={state.purposeConsultationTabIsOpen}
              >
                <div className="container p-3 bg-white">
                  <textarea
                    style={{
                      boxShadow: "none",
                      resize: "none",
                      border: "0",
                      height: "75px",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "18px",
                      background: "#fff",
                    }}
                    name="consultation_purpose"
                    className="form-control textarea-purpose"
                    value={
                      state.consultationPurpose ? state.consultationPurpose : ""
                    }
                    disabled
                  ></textarea>
                </div>
              </Collapse>
              <br />
              {renderPEMButton()}
              <h2 className="pl-0 mt-2 pr-4 pb-0 mb-0">Prescriptions</h2>

              <PrescriptionComponent
                appointmentData={state.appointmentData}
                age={state.age}
                patientId={state?.appt_id?.patient_id}
                patientAccountId={state?.appt_id?.patient_account_id}
                setDrowerPostionInitianlView={() => {}}
              />

              <h2 className="pl-0 mt-4 pr-4 pb-0 mb-0">
                Patient's Medical History
              </h2>
              <h3
                className="py-3 pl-3 pr-4 pb-0 mb-0 mt-0 doctor-video-collapse-header"
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    documentsTabIsOpen: !prevState.documentsTabIsOpen,
                    newFileAdded: 0,
                  }))
                }
              >
                Documents (
                {state.prescriptionHistory?.length +
                  state.receiverDocuments?.length}
                )
                {state.documentsTabIsOpen ? (
                  <i className="fa fa-angle-up"></i>
                ) : (
                  <i className="fa fa-angle-down"></i>
                )}
              </h3>

              <Collapse id="basicCollapse2" in={state.documentsTabIsOpen}>
                <div className="container prescription-upload-container py-3 border-1 top-border-none">
                  {state.prescriptionHistory?.length ||
                  state.receiverDocuments ? (
                    [
                      ...state.prescriptionHistory,
                      ...state.receiverDocuments,
                    ].map((result, index) => {
                      const lastDot = result?.document_title
                        ? result?.document_title?.lastIndexOf(".")
                        : result?.file_path?.lastIndexOf(".");
                      const fileName = result?.document_title
                        ? result?.document_title?.substring(0, lastDot)
                        : result?.file_path?.substring(0, lastDot);
                      const fileType = result.document_title
                        ? result?.document_title?.substring(lastDot + 1)
                        : result?.file_path?.substring(lastDot + 1);
                      return (
                        <div
                          className="prescription-history-container d-flex justify-content-between"
                          key={index}
                        >
                          <div style={{ width: "50%" }}>
                            {" "}
                            {/**"23%" */}
                            <div className="medical-record-heading">
                              {fileName}
                            </div>
                            <div className="medical-record-date">
                              {moment(result.created_at).format(
                                "hh:mm A | DD MMM, YYYY"
                              )}
                            </div>
                            <div className="medical-record-date d-flex">
                              {fileType}
                              <span className="bullet mt-2 mx-1"></span>
                              {result.file_size}MB
                            </div>
                          </div>
                          <div className="medical-record-container">
                            {moment().isAfter(moment(result.created_at)) &&
                            moment().isBefore(
                              moment(result.created_at).add(5, "m")
                            ) ? (
                              <span className="medical-record-new">New</span>
                            ) : null}
                            <div className="ml-3 mt-1">
                              {fileType.toLowerCase().includes("pdf") ||
                              fileType.toLowerCase().includes("jpg") ||
                              fileType.toLowerCase().includes("png") ||
                              fileType.toLowerCase().includes("jpeg") ? (
                                <i
                                  className=" medical-record-icon m-1"
                                  onClick={() =>
                                    viewDocument(result, fileType, fileName)
                                  }
                                >
                                  <VisibilityIcon fontSize="small" />
                                </i>
                              ) : (
                                <i className=" view-disable-icon m-1">
                                  <VisibilityIcon fontSize="small" />
                                </i>
                              )}
                              <span
                                onClick={() => {
                                  setState((prevState) => ({
                                    ...prevState,
                                    prescriptionHistory:
                                      state.prescriptionHistory.map((item) => {
                                        item.document_id ==
                                          result.document_id && delete item.new;
                                        return item;
                                      }),
                                  }));
                                  downloadURI(
                                    result.presigned_url,
                                    fileName,
                                    fileType
                                  );
                                }}
                              >
                                <i className="medical-record-icon m-1">
                                  <GetAppIcon fontSize="small" />
                                </i>
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-center">
                      <p>NO RECORD FOUND</p>
                    </div>
                  )}
                </div>
              </Collapse>
            </div>
            <br />
            {state.consentFlag && (
              <span
                style={{
                  color: "#F969A4",
                  fontSize: "10px",
                  fontWeight: "bold",
                }}
              >
                Consent required to save prescription.
                <br />
              </span>
            )}
          </div>
        </div>
      </section>

      <div className="row">
        <div className="col-sm-12 p-0"></div>
      </div>

      <Modal
        size="lg"
        show={state.showPres}
        onHide={closePres}
        className="modal"
      >
        <button className="btn btn-sm btn-dark" onClick={closePres}>
          Close Prescription
        </button>
        <div className="modal-body p-5">
          <div className="maintable">
            <div className="container">
              <div className="top-ttl b-bm">
                {state.appt_id && (
                  <div className="row  ">
                    <div className="col-md-2 date pt-3">
                      <b>
                        <strong>
                          Dr. {state.appt_id.first_name}{" "}
                          {state.appt_id.last_name}
                        </strong>
                      </b>
                      <br />
                      <span style={{ color: "#F969A4" }}>
                        {state.appt_id.degree}
                      </span>{" "}
                      <br />
                    </div>
                    <div className="col-md-7">
                      Name: <b> {state.appt_id.patient_name} </b> <br />
                      Phone No: <b> {state.appt_id.phone_no} </b>
                      <br />
                      Address: <b> {state.appt_id.patient_city} </b> <br />
                      Appointment Date:{" "}
                      <b>
                        {moment(state.appt_id.appointment_date).format(
                          "DD-MM-YYYY"
                        )}
                        , &nbsp;
                        {state.appt_id.start_time} for 30 min{" "}
                      </b>{" "}
                      <br />
                      Appointment Time:{" "}
                      <b>{state.appt_id.start_time} for 30 min </b>
                    </div>

                    <div className="col-md-3">
                      <div className="add-rec">
                        <form>
                          <label>Add Records</label>
                          <select
                            className="form-control"
                            name="add_record"
                            id="add_record"
                            onChange={() => createRecord("add_record")}
                          >
                            <option value="">Create Record</option>
                            <option value="1">lab Orders</option>
                            <option value="2">Medications</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="patient-data">
                <form>
                  <div className="row b-bm">
                    <div className="patient-content">
                      <ul>
                        <li>
                          <div className="row">
                            <div className="col-12">
                              <h6 style={{ color: "#616161" }}>
                                Clinical Notes
                              </h6>
                            </div>
                            <div className="col-md-4">Complaints</div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                id="complaints"
                                name="complaints"
                                value={state.complaints}
                                onChange={() => handleChange("complaints")}
                              />
                              <span style={{ color: "#F969A4" }}>
                                {state.formErrors["complaints"]}
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="row">
                            <div className="col-md-4">Observations</div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                id="observations"
                                name="observations"
                                value={state.observations}
                                onChange={() => handleChange("observations")}
                              />
                              <span style={{ color: "#F969A4" }}>
                                {state.formErrors["observations"]}
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="row">
                            <div className="col-md-4">Diagnosis</div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                id="diagnosis"
                                name="diagnosis"
                                value={state.diagnosis}
                                onChange={() => handleChange("diagnosis")}
                              />
                              <span style={{ color: "#F969A4" }}>
                                {state.formErrors["diagnosis"]}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-4">Recommendation</div>
                            <div className="col-md-8 text-left">
                              <select
                                className="w-100"
                                style={{ height: "50px" }}
                                name="selectRecommendation"
                                id="selectRecommendation"
                                onChange={() => selectRecommendation()}
                              >
                                <option value="0">None</option>
                                <option value="1">In-person Visit</option>
                                <option value="2">Virtual Visit</option>
                              </select>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="row b-bm">
                    <div className="patient-content">
                      <ul
                        id="dynamic-list_lab_order"
                        name="dynamic-list_lab_order"
                      >
                        <li>
                          <div className="row ">
                            <div className="col-12">
                              <h6 style={{ color: "#616161" }}>Lab Orders</h6>
                            </div>
                            <div className="col-md-6">Test</div>
                            <div className="col-md-6">INSTRUCTION</div>
                          </div>
                        </li>
                        {state.lab_results.length > 0
                          ? state.lab_results.map((Data, index) => {
                              return (
                                <li
                                  id={"li_lab_order_" + index}
                                  name={"li_lab_order_" + index + "[]"}
                                >
                                  <div className="row mb-3">
                                    <div className="col-md-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={"lab_order_test_" + index}
                                        name={"lab_order_test_" + index}
                                        data-index={index}
                                        data-text="test"
                                        defaultValue={Data.test}
                                        onChange={() =>
                                          handleChange("lab_orders")
                                        }
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={"lab_order_inst_" + index}
                                        name={"lab_order_inst_" + index}
                                        data-index={index}
                                        data-text="instruction"
                                        defaultValue={Data.instruction}
                                        onChange={() =>
                                          handleChange("lab_orders")
                                        }
                                      />
                                    </div>
                                  </div>
                                </li>
                              );
                            })
                          : ""}
                      </ul>
                    </div>
                  </div>
                  <div className="row b-bm">
                    <div className="patient-content">
                      <ul
                        id="dynamic-list_medication"
                        name="dynamic-list_medication"
                      >
                        <li>
                          <div className="row ">
                            <div className="col-12">
                              <h6 style={{ color: "#616161" }}>Medications</h6>
                            </div>
                          </div>
                        </li>
                        {state.medication.length > 0
                          ? state.medication.map((Data, index) => {
                              return (
                                <li
                                  id={"li_medication_" + index}
                                  name={"li_medication_" + index + "[]"}
                                >
                                  <div className="row mb-3">
                                    <div className="col-md-12">DRUG </div>
                                    <div className="col-md-12">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={"medication_drug_" + index}
                                        name={"medication_drug_" + index}
                                        data-index={index}
                                        data-text="drug"
                                        defaultValue={Data.drug}
                                        onChange={() =>
                                          handleChange("medication")
                                        }
                                      />
                                    </div>
                                    <div className="col-md-6">FREQUENCY </div>
                                    <div className="col-md-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={"medication_frequency_" + index}
                                        name={"medication_frequency_" + index}
                                        data-index={index}
                                        data-text="frequency"
                                        defaultValue={Data.frequency}
                                        onChange={() =>
                                          handleChange("frequency")
                                        }
                                      />
                                    </div>
                                    <div className="col-md-6">DURATION </div>
                                    <div className="col-md-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="medication_duration"
                                        name="medication_duration"
                                        data-index={index}
                                        data-text="duration"
                                        defaultValue={Data.duration}
                                        onChange={() =>
                                          handleChange("medication")
                                        }
                                      />
                                    </div>
                                    <div className="col-md-12">
                                      INSTRUCTIONS
                                    </div>
                                    <div className="col-md-12">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={"medication_instruction_" + index}
                                        name={"medication_instruction_" + index}
                                        data-index={index}
                                        data-text="instruction"
                                        defaultValue={Data.instruction}
                                        onChange={() =>
                                          handleChange("instruction")
                                        }
                                      />
                                    </div>
                                  </div>
                                </li>
                              );
                            })
                          : ""}
                      </ul>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-lg mt-2"
                    style={{
                      color: "#454545",
                      backgroundColor: "#F969A4",
                      padding: "8px 70px",
                    }}
                    onClick={() => onSubmit()}
                  >
                    <b>Save</b>
                  </button>
                  <br />
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {state.confirmModal && (
        <Modal
          show={state.confirmModal}
          onHide={closeConfirm}
          centered
          className="end-call-confirmation"
        >
          <Modal.Body>
            <div className="py-sm-5 py-lg-4 py-5 px-5 my-2">
              <div className=" text-center mt-3 ">
                <h4 className="px-2" style={{ color: "1B2027" }}>
                  <b>Are you sure you want to end this call?</b>
                </h4>
                <div className=" container p-2 mb-3 text-center">
                  <div>
                    <p style={{ fontSize: "18px" }}>
                      Once ended, you cannot rejoin the call
                    </p>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="text-center">
                  <Button
                    className="btn btn-lg border-0 mb-md-2 mx-3 border rounded-pill coupon-confirm-button"
                    style={{ backgroundColor: "#17BAE0", color: "#fff" }}
                    onClick={() => {
                      setState((prevState) => ({
                        ...prevState,
                        confirmModal: false,
                      }));
                      setState((prevState) => ({
                        ...prevState,
                        showPEMShare: true,
                        isEndButtonClick: true,
                      }));
                    }}
                  >
                    Yes
                  </Button>

                  <Button
                    className="btn btn-lg border  mb-md-2  mx-3 rounded-pill coupon-confirm-button"
                    style={{ backgroundColor: "#fff", color: "#17BAE0" }}
                    onClick={() => {
                      setState((prevState) => ({
                        ...prevState,
                        confirmModal: false,
                        isEndButtonClick: false,
                      }));
                    }}
                  >
                    No
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      <Modal
        dialogClassName="main_modal"
        show={state.setLgShow}
        onHide={() =>
          setState((prevState) => ({ ...prevState, setLgShow: false }))
        }
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {state.viewPrescription ? (
            <PrescriptionPdf
              appointment_id={state.appt_id.id}
              from_dr_video={true}
            />
          ) : null}
        </Modal.Body>
      </Modal>
      <DoctorPostShare
        open={state.openSharPost}
        onClose={() =>
          setState((prevState) => ({ ...prevState, openSharPost: false }))
        }
        appointment={state.appt_id}
        endmeeting={() => endMeetingConfirm()}
      />

      <div>
        <NotifiVisitor
          setClass={state.notifiVisitorCondition ? "isActive" : " "}
          onHide={setNotifiVisitorCondition}
          patientName={localStorage.getItem("next_patient")}
          time={localStorage.getItem("next_meeting")}
          instantRescheduleAppointmentNotifi={
            instantRescheduleAppointmentNotifi
          }
          instantCancelAppointment={instantCancelAppointment}
        />

        <ReScheduledModal
          show={state.isRescheduleClicked}
          handleClose={() => {
            notiFiHandleClose();
          }}
          rescheduleData={instantReScheduledModal}
        />
        <ReScheduledConformModal
          show={state.messageSentModal}
          closeReschedule={() => {
            notiFiClosePopup();
          }}
        />
        <CancelAppointmentModal
          show={state.cancelAppointmentModalOprn}
          handleClose={() => {
            cancelAppointmentModalClose();
          }}
          cancelAppointInstantData={() => {
            cancelAppointInstantData();
          }}
          fees={localStorage.getItem("instant_consult_fees")}
        />

        <CallModal
          openView={state.showCallPatientModal}
          closeView={() => setShowCallPatientModal()}
          modalCloseView={() => setShowCallPatientModal()}
          appointment_id={state.appt_id.id}
          patientName={state.appt_id.patient_name}
        />

        <OnHoldModal
          showOnHoldModal={state.showOnHoldModal}
          closeOnHoldModal={() => {
            setState((prevState) => ({ ...prevState, showOnHoldModal: false }));
          }}
          clearIntervals={() => {
            clearInterval(myInterval);
            clearInterval(myInterval1);
          }}
        />
      </div>
      <Popup
        title={"Patient Education Content Shared!"}
        show={state.showPopUp}
        handleClose={() =>
          setState((prevState) => ({ ...prevState, showPopUp: false }))
        }
      />
      {state.showNotification && (
        <Notification
          show={state.showNotification}
          content={state.notification}
          cancelHandler={closeNotification}
          successHandler={successNotification}
        />
      )}
    </div>
  );
};
export default DoctorVideoComponent;
